import { render, staticRenderFns } from "./userChatImage.vue?vue&type=template&id=61e34042&"
import script from "./userChatImage.vue?vue&type=script&lang=js&"
export * from "./userChatImage.vue?vue&type=script&lang=js&"
import style0 from "./userChatImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports